import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70' : 'bg-transparent'
    }`}>
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-tv-2-line text-lg"></i>
            </span>
            <span className="font-heading text-xl text-foreground-950 whitespace-nowrap">人人美剧</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about') ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-700 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <div className="flex flex-col gap-2 pt-2">
            <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap">首页</Link>
            <Link to="/category/all" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap">分类浏览</Link>
            <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}